import React from 'react';
import { Calendar, UserRound } from 'lucide-react';
import DoctorAvatar from './DoctorAvatar';

export default function DoctorProfileCard({ doctor, primary, onView, onBook, testId }) {
  return (
    <article
      className="rounded-2xl border border-white/8 bg-gradient-to-br from-white/[0.05] to-transparent overflow-hidden hover:border-white/16 transition"
      data-testid={testId}
    >
      <div className="p-4 sm:p-5">
        <div className="flex items-start gap-3.5">
          <DoctorAvatar doctor={doctor} primary={primary} size="md" />
          <div className="min-w-0 flex-1">
            <p className="font-semibold text-zinc-50 text-[15px] leading-snug">{doctor.name}</p>
            {doctor.title && <p className="text-[11px] text-zinc-500 mt-0.5">{doctor.title}</p>}
            <p className="text-[12px] font-medium mt-1.5" style={{ color: primary }}>
              {doctor.specialization || 'General consultation'}
            </p>
            {doctor.qualifications ? (
              <p className="text-[11px] text-zinc-500 mt-1 line-clamp-2">{doctor.qualifications}</p>
            ) : null}
          </div>
        </div>
        {doctor.bio && (
          <p className="mt-3 text-[12.5px] text-zinc-400 leading-relaxed line-clamp-3">
            {doctor.bio}
          </p>
        )}
        <div className="mt-4 flex gap-2">
          <button
            type="button"
            onClick={() => onView(doctor)}
            className="flex-1 inline-flex items-center justify-center gap-1.5 text-[12px] font-medium py-2 rounded-full border border-white/12 text-zinc-200 hover:bg-white/5"
            data-testid={`${testId}-view`}
          >
            <UserRound className="h-3.5 w-3.5" /> Profile
          </button>
          {doctor.bookable !== false && (
            <button
              type="button"
              onClick={() => onBook(doctor)}
              className="flex-1 inline-flex items-center justify-center gap-1.5 text-[12px] font-semibold py-2 rounded-full text-white"
              style={{ background: primary }}
              data-testid={`${testId}-book`}
            >
              <Calendar className="h-3.5 w-3.5" /> Book
            </button>
          )}
        </div>
      </div>
    </article>
  );
}
